export enum Abrechnungsklasse {
    SLP = 'SLP',
    RLM = 'RLM'
}

export class AbrechnungsklasseItem {

    public key: string;
    public description: string;

    constructor(key: string, description: string) {
        this.key = key;
        this.description = description;
    }

    public static getAll(): AbrechnungsklasseItem[] {
        return [
            new AbrechnungsklasseItem(Abrechnungsklasse.SLP, 'SLP'),
            new AbrechnungsklasseItem(Abrechnungsklasse.RLM, 'RLM'),
        ];
    }

}

